import type { Terminal } from '../terminal';
import { FAST_TYPE_SPEED } from '../terminal';

const BOOT_LINES = [
  '',
  '  ╔════════════════════════════════════════════════════════╗',
  '  ║  WOPR  --  WAR OPERATION PLAN RESPONSE                 ║',
  '  ║  STRATCOM NORAD COMPLEX  --  CHEYENNE MOUNTAIN         ║',
  '  ║  SYSTEM VERSION 4.11.7  (C) 1983 PROTOVISION           ║',
  '  ╚════════════════════════════════════════════════════════╝',
  '',
];

const SYSTEM_CHECKS = [
  'INITIALIZING SYSTEM...',
  '',
  'CENTRAL PROCESSOR............. ONLINE',
  'MEMORY ALLOCATION............. 65536K OK',
  'DEFENSE NETWORK INTERFACE..... CONNECTED',
  'PRIMARY RADAR FEED............ ACTIVE',
  'SECONDARY RADAR FEED.......... ACTIVE',
  'SATELLITE UPLINK.............. NOMINAL',
  'STRATEGIC AIR COMMAND......... LINKED',
  'FLEET BALLISTIC MISSILE....... LINKED',
  'EARLY WARNING SYSTEM.......... OPERATIONAL',
  '',
  'RUNNING DIAGNOSTICS...',
  '',
  'TARGETING COMPUTER............ CALIBRATED',
  'TRAJECTORY CALCULATOR......... OPERATIONAL',
  'DAMAGE ASSESSMENT MODULE...... LOADED',
  'AI STRATEGY CORE.............. INITIALIZED',
  'GAME THEORY DATABASE.......... 14,209 SCENARIOS',
  '',
  'ALL SYSTEMS NOMINAL.',
  '',
  '════════════════════════════════════════════════════════════════',
  '',
];

async function runBootSequence(terminal: Terminal): Promise<void> {
  terminal.setTypingSpeed(FAST_TYPE_SPEED);

  for (const line of BOOT_LINES) {
    await terminal.println(line, { speed: 4 });
  }

  await terminal.pause(500);

  for (const line of SYSTEM_CHECKS) {
    if (line === '') {
      await terminal.println('');
      continue;
    }

    if (line.includes('...') && !line.endsWith('...')) {
      // System check line - type the label, then pause, then result
      const parts = line.split(/(?<=\.{2,})\s*/);
      if (parts.length >= 2) {
        const [label, ...rest] = parts;
        await terminal.print(label ?? '', { speed: 3 });
        await terminal.pause(100 + Math.random() * 300);
        await terminal.println(' ' + rest.join(' '), { speed: 2 });
      } else {
        await terminal.println(line, { speed: 3 });
      }
    } else {
      await terminal.println(line, { speed: FAST_TYPE_SPEED });
      if (line.endsWith('...')) {
        await terminal.pause(400 + Math.random() * 600);
      }
    }
  }

  terminal.setTypingSpeed(30);
}

export { runBootSequence };
